import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { usePeut } from '../../auth/usePeut.js';
import pageStyles from '../../styles/page.module.css';
import { DepotsBloc } from './reprise/DepotsBloc.js';
import { LiensDepotBloc } from './reprise/LiensDepotBloc.js';
import { LotFiche } from './reprise/LotFiche.js';
import { LotsBloc } from './reprise/LotsBloc.js';
import { MandatBloc } from './reprise/MandatBloc.js';
import { PlanBloc } from './reprise/plan/PlanBloc.js';
import styles from './reprise/Reprise.module.css';

/**
 * Fiche galerie › Reprise (ARTO-126, ARTO-129, ARTO-132) : le plan, le mandat, les lots, puis
 * les dépôts de fichiers et les liens de dépôt. Un lot s'ouvre dans l'onglet
 * même (`?lot=…`) : le retour du navigateur revient à la liste, et le lien de
 * la fiche se partage.
 */
export function RepriseTab({ idGalerie }: { idGalerie: string }): JSX.Element {
  const { t } = useTranslation('console');
  const peut = usePeut();
  const [parametres] = useSearchParams();
  const lotId = parametres.get('lot');

  if (!peut('console:run-import')) {
    return <p className={pageStyles.videEtat}>{t('reprise.reserve')}</p>;
  }
  if (lotId) return <LotFiche idGalerie={idGalerie} lotId={lotId} />;
  return (
    <div className={styles.pile}>
      <PlanBloc idGalerie={idGalerie} />
      <MandatBloc idGalerie={idGalerie} />
      <LotsBloc idGalerie={idGalerie} />
      <DepotsBloc idGalerie={idGalerie} />
      <LiensDepotBloc idGalerie={idGalerie} />
    </div>
  );
}
